// FILEPATH: c:/Users/Sign Blast/Desktop/lss2-react/src/pages/Landing.js

import React from 'react';
import './Landing.css';
import logo from '../assets/LED-Speed-Signs-Logo.png';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import { Button, ThemeProvider, createTheme } from '@mui/material';

const Landing = () => {
  const navigate = useNavigate();

  const handleSignIn = () => {
    navigate('/signin');
  };

  const handleDataSignIn = () => {
    navigate('/data-signin');
  };

  const handleInspectionSignIn = () => {
    navigate('/inspection-signin');
  };

  const handleHomeRedirect = () => navigate('/');


  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      margin: 0,
      padding: 0,
      overflow: 'hidden'
    }}>
      {/* Landing page content above the fox */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: '#ececec',
        padding: '40px',
        borderRadius: '10px',
        boxShadow: '0 10px 20px rgba(0, 0, 0, 0.3)',
        textAlign: 'center',
        width: '400px',
        maxWidth: '90%',
        zIndex: 10
      }}>
        <img src={logo} alt="LSS Logo" className="logo" />
        <h1></h1>
        <div className="button-group">
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleSignIn}
            className="btn"
            fullWidth
          >
            Control Portal
          </Button>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleDataSignIn}
            className="btn"
            fullWidth
          >
            Data Portal
          </Button>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleInspectionSignIn}
            className="btn"
            fullWidth
          >
            Inspection Portal
          </Button>
        </div>
        <Button 
            variant="outlined"
            onClick={handleHomeRedirect}
            className="btn"
            sx={{ 
                marginTop: '20px', 
                width: '100%',
                backgroundColor: 'transparent !important',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                color: 'white',
                '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    borderColor: 'rgba(255, 255, 255, 0.7)'
                }
            }}
          >
            Return to Home
          </Button>
      </div>
    </div>
  );
};

export default Landing;